import { InfiniteScroll } from "@inertiajs/react";
import type { ReactNode } from "react";

/**
 * Shared reviews scroll region for the product/service show pages: keeps the
 * auto-load trigger inside the reviews panel (via ShowView's
 * `reviewsListWrapper` slot) rather than at page bottom.
 */
export function wrapReviewsInScroll(reviewsList: ReactNode): ReactNode {
  return (
    <InfiniteScroll data="reviews" preserveUrl onlyNext>
      {reviewsList}
    </InfiniteScroll>
  );
}
